import React, { FC, useEffect, useMemo } from "react";
import { Table } from "@mantine/core";
import myDataAssets from "../../utils/data_assets.json";
import { DataAssetsType } from "@/types/apiTypes";
import { flattenData } from "@/utils/flattenData";
import { Text } from "@/components/Generics/Text";
import { useAppColors } from "@/hooks/contextHooks/useAppColors";

interface ShipDataTableProps {
  data: Record<string, any>;
}

const dataAssets: DataAssetsType = myDataAssets;

const ShipDataTable: FC<ShipDataTableProps> = ({ data }) => {
  useEffect(() => {
    console.log("ShipDataTable received new data:", data);
  }, [data]);
  const { colors } = useAppColors();

  const dataForTable = useMemo(() => {
    const flattenedData = flattenData(data);

    const filteredData = Object.keys(dataAssets.vessel_details).reduce(
      (acc, key) => {
        const fullKey = `dtwin.vessel.${key}`;
        if (flattenedData[fullKey] !== undefined) {
          acc[key] = flattenedData[fullKey];
        }
        return acc;
      },
      {} as Record<string, any>,
    );

    return Object.entries(filteredData).map(([key, value]) => {
      const asset =
        dataAssets.vessel_details[
          key as keyof typeof dataAssets.vessel_details
        ];
      return {
        Label: asset?.label || key,
        Value:
          typeof value === "object" ? JSON.stringify(value, null, 2) : value,
        Unit: asset?.unit || "",
      };
    });
  }, [data]);

  return (
    <Table
      mt={10}
      style={{
        width: "100%",
      }}
    >
      <thead>
        <tr>
          <th style={{ textAlign: "left" }}>
            <Text color={colors.secondary}>Label</Text>
          </th>
          <th style={{ textAlign: "left" }}>
            <Text color={colors.secondary}>Value</Text>
          </th>
          <th style={{ textAlign: "left" }}>
            <Text color={colors.secondary}>Unit</Text>
          </th>
        </tr>
      </thead>
      <tbody>
        {dataForTable.map((row, index) => (
          <tr key={index}>
            <td>
              <Text size="small" color={colors.secondary}>
                {row.Label}
              </Text>
            </td>
            <td style={{ whiteSpace: "pre-wrap" }}>
              <Text size="small" color={colors.secondary}>
                {row.Value}
              </Text>
            </td>
            <td>
              <Text size="small" color={colors.secondary}>
                {row.Unit}
              </Text>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ShipDataTable;
